<div class="route-steps d-flex pt-2">
    <ul class="timeline">
        <li *ngFor="let step of session.route;let index = index;" [ngClass]="{'mb-3' : index<session.route.length-1}">
            <span>
                <span class="timeline-icon bg-dark">
                    <i class='bx bx-play' *ngIf="index == 0 && step != 'RESTART'"></i>
                    <i class='bx bx-down-arrow-alt' *ngIf="index>0 && index<session.route.length-1 && step != 'RESTART'"></i>
                    <i class='bx bxs-flag-checkered' *ngIf="index>0 && index == session.route.length-1 && step != 'RESTART'"></i>
                    <i class='bx bx-refresh' *ngIf="step == 'RESTART'"></i>
                </span>
                <span class="timeline-title">
                    <ng-container *ngIf="step == 'RESTART'">Restarted</ng-container>
                    <ng-container *ngIf="step != 'RESTART' && step">
                        {{ getStep(step, scenario) ? getStep(step, scenario)?.title :
                        'DELETED' }}
                    </ng-container>


                </span>
                <span class="timeline-time" *ngIf="index<session.route.length-1"> &nbsp;</span>
            </span>
        </li>
    </ul>
</div>